import { render, staticRenderFns } from "./page22.vue?vue&type=template&id=01544141&scoped=true&"
import script from "./page22.vue?vue&type=script&lang=js&"
export * from "./page22.vue?vue&type=script&lang=js&"
import style0 from "./page22.vue?vue&type=style&index=0&id=01544141&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01544141",
  null
  
)

export default component.exports